import type { OpenAPIV3 } from "openapi-types";
import { parseSpec } from "./parser";
import { createMockServer } from "./server";
import type { MockAPIServer, MockServerOptions, SpecInput } from "./types";

export type { MockAPIServer, MockServerOptions };
export type { OpenAPIV3 } from "openapi-types";

/**
 * Create a mock API server from an OpenAPI spec path or inline document.
 */
export async function mockAPI(
  spec: SpecInput,
  options: MockServerOptions = {}
): Promise<MockAPIServer> {
  const parsed = await parseSpec(spec);
  return createMockServer(parsed, options);
}


